<template>
  <ul class="contains-task-list test">
    <li class="task-list-item">
      <input type="checkbox"> 可选择的
    </li>
    <li class="task-list-item">
      <input type="checkbox" checked> 可选择的选中的
    </li>
    <li class="task-list-item">
      <input type="checkbox" disabled> 不可选择的
    </li>
    <li class="task-list-item">
      <input type="checkbox" disabled checked> 不可选择的选中的
    </li>
  </ul>
</template>
